import React from "react";
import { Helmet } from "react-helmet";

const DefaultSEO = () => {

  return (
    <Helmet>

      {/* Default Title */}
      <title>
        Chrisalpha Tech Company Ltd | Apps, POS Systems & IT Services in Uganda
      </title>

      {/* Default Description */}
      <meta
        name="description"
        content="Chrisalpha Tech Company Ltd provides software development, POS systems, websites, mobile apps and IT solutions in Uganda."
      />

      {/* Keywords */}
      <meta
        name="keywords"
        content="CHRISALPHA TECH COMPANY LTD is a professional software development and information technology company dedicated to
 delivering high-quality digital solutions. The company specializes in the design, development, and implementation of 
 reliable and scalable software systems tailored for businesses, organizations, and institutions."
      />

      {/* Author */}
      <meta
        name="author"
        content="Chrisalpha Tech Company Ltd"
      />

      {/* Open Graph */}
      <meta property="og:title" content="Chrisalpha Tech Company Ltd" />

      <meta
        property="og:description"
        content="Software development, POS systems and IT services in Uganda."
      />

      <meta
        property="og:image"
        content="https://chrisalphatech.com/logo.png"
      />

      <meta
        property="og:url"
        content="https://chrisalphatech.com"
      />

    </Helmet>
  );

};

export default DefaultSEO;